import styled from 'styled-components';
import {
    Box,
    Button,
    InfoFilled as InfoFilledMaestro,
    Text,
    palette,
    spacing,
} from '@landr/maestro';

export const CloseButton = styled(Button)`
    padding-left: ${spacing('md')};
    padding-right: ${spacing('md')};
`;

export const InModalNotification = styled(Box)`
    display: flex;
    background-color: ${palette('primary.300')};
    background-color: #e6f8f8;
    padding: ${spacing('md')};
    border-radius: 4px;
`;

export const InfoFilled = styled(InfoFilledMaestro)`
    color: ${palette('primary.500')};
`;

export const Icon = styled(Box)`
    display: flex;
    align-items: start;
    font-size: 0;
    padding: 0;
    margin-right: ${spacing('md')};
`;

export const Content = styled(Text)`
    align-items: center;
`;
